export default function LateEarlyModal({ isOpen, onClose, lateUsers, earlyUsers }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="
        w-full max-w-md
        rounded-2xl
        bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        shadow-2xl border border-white/20
        text-white
      ">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold tracking-wide">
            Late / Early Employees
          </h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-red-400 transition"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-6">

          {/* LATE */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-2.5 h-2.5 bg-red-400 rounded-full" />
              <span className="text-sm font-semibold text-red-300">
                Late ({lateUsers.length})
              </span>
            </div>

            {lateUsers.length === 0 ? (
              <p className="text-xs text-white/50 ml-4">No late employees 🎉</p>
            ) : (
              <div className="space-y-2">
                {lateUsers.map(u => (
                  <div key={u.user_id}
                    className="
                      flex justify-between items-center
                      px-4 py-2
                      rounded-xl
                      bg-white/10 backdrop-blur
                      border border-white/10
                    ">
                    <span className="text-sm">{u.name}</span>
                    <span className="
                      text-xs px-2 py-0.5 rounded-full
                      bg-red-500/30 text-red-200
                    ">
                      {u.punch_in}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Divider */}
          <div className="h-px bg-white/10" />

          {/* EARLY */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-2.5 h-2.5 bg-green-400 rounded-full" />
              <span className="text-sm font-semibold text-green-300">
                Early ({earlyUsers.length})
              </span>
            </div>

            {earlyUsers.length === 0 ? (
              <p className="text-xs text-white/50 ml-4">No early employees</p>
            ) : (
              <div className="space-y-2">
                {earlyUsers.map(u => (
                  <div key={u.user_id}
                    className="
                      flex justify-between items-center
                      px-4 py-2
                      rounded-xl
                      bg-white/10 backdrop-blur
                      border border-white/10
                    ">
                    <span className="text-sm">{u.name}</span>
                    <span className="
                      text-xs px-2 py-0.5 rounded-full
                      bg-green-500/30 text-green-200
                    ">
                      {u.punch_in}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end px-5 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="
              px-5 py-2 rounded-lg
              bg-purple-600 hover:bg-purple-500
              transition
            "
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
